<template>
  <table-layout>
    <template v-slot:button v-if="isAdmin">
      <v-btn class="button save" outlined @click="modifyUser" :disabled="!selectDataLength">수정</v-btn>
      <v-btn v-if="isAdmin" class="button delete" outlined @click="isDeleteMember" :disabled="!selectDataLength">삭제</v-btn>
    </template>
    <template v-slot:table>
      <v-data-table
        v-model="selectData"
        height="50vh"
        :headers="getHeader(headers)"
        :items="memberList"
        no-data-text="조회된 데이터가 없습니다"
        fixed-header
        :items-per-page="-1"
        show-select item-key="index"
        mobile-breakpoint="md"
      >
        <template v-slot:item.memberRole="{ value }">
          <div>{{ dataConversion(memberRoleList, value) }}</div>
        </template>
        <template v-slot:item.telNum="{ value }">
          <div>{{ setTelNum(value) }}</div>
        </template>
        <template v-slot:item.ssno="{ value }">
          <div>{{ setSsnoMasking(value) }}</div>
        </template>
        <template v-slot:item.loanBrokerNo="{ value }">
          <div>{{ setLoanBrokerNoFormat(value) }}</div>
        </template>
        <template v-slot:item.reset="{ item }">
          <v-btn class="button delete" outlined @click="isReset(item)">초기화</v-btn>
        </template>
      </v-data-table>
    </template>
    <template v-slot:popup>
      <member-modify
        :is-show="isShowModify"
        :member-info="memberInfo"
        @refresh="refreshOrgMemberList"
        @close="isShowModify = false"
      />
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import {ORG_MEMBER_LIST_TABLE} from "@/util/TableHeaders";
import MemberModify from "@/pages/Member/popup/MemberModify.vue";
import constant from "@/util/constant";
import _ from "lodash";

export default {
  name: "OrgMemberList",
  components: {MemberModify, TableLayout},
  props: ["selectedData"],
  mixins: [TableMixin],
  data() {
    return {
      memberRoleList: constant.MEMBER_ROLE_LIST,
      headers: ORG_MEMBER_LIST_TABLE,
      memberList: [],
      selectData: [],
      memberInfo: {},
      isShowModify: false
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId",
      userData: "userData",
      isAdmin: "isAdmin"
    }),
    selectDataLength() {
      return this.selectData.length > 0;
    }
  },
  watch: {
    selectedData(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectData = [];
        this.getOrgMemberList();
      }
    }
  },
  mounted() {
    if (!_.isEmpty(this.selectedData)) {
      this.getOrgMemberList();
    }
  },
  methods: {
    async getOrgMemberList() {
      const orgCd = this.selectedData.type === "ORG"
          ? this.selectedData.id
          : this.selectedData.upperOrgCd;
      try {
        const { data } = await axiosInstance.get("/private/member/list", {
          params: {
            memberId: this.memberId,
            orgCd: orgCd,
            name: "",
            delYn: "N"
          }
        });
        if (data.length < 1) {
          this.memberList = [];
        } else {
          let idx = 0;
          for (const item of data) {item["index"] = idx++}
          this.memberList = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    async modifyUser() {
      if (this.selectData.length > 1) {
        await this.showAlert({message: "수정데이터는 한개의 목록만 선택해주세요"});
        return false;
      }
      await this.getMemberInfo();
      this.isShowModify = true;
    },
    async getMemberInfo() {
      try {
        const { data } = await axiosInstance.get("/private/member/info", {
          params: {
            memberId: this.selectData[0].memberId
          }
        });
        if (!data) {
          this.memberInfo = {};
        }
        else {
          this.memberInfo = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    isDeleteMember() {
      const deleteMembers = this.selectData.map(item => item.memberNm).join(",");
      this.showConfirm({
        message: `${deleteMembers}님의 데이터를 삭제하시겠습니까?`,
        successCallback: () => {
          this.deleteMember();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async deleteMember() {
      try {
        for (let i = 0; i < this.selectData.length; i++) {
          await axiosInstance.delete("/admin/member", {
            params: {
              delYn: "Y",
              memberId: this.selectData[i].memberId,
              adminId: this.memberId
            }
          })
        }
        await this.showAlert({
          message: "선택된 모든 사용자가 삭제 완료되었습니다",
          successCallback: () => {
            this.refreshOrgMemberList();
          }
        });
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    refreshOrgMemberList() {
      this.selectData = [];
      this.getOrgMemberList();
      this.$emit("refresh");
    },
    isReset(item) {
      this.showConfirm({
        message: `${item.memberNm}님의 비밀번호를 초기화하시겠습니까?`,
        successCallback: () => {
          this.resetPassword(item);
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async resetPassword(item) {
      await axiosInstance.patch("/admin/member/password-reset", {}, {
        params: {
          adminId: this.memberId,
          memberId: item.memberId
        }
      }).then(() => {
        this.showAlert({message: "초기화가 완료되었습니다"});
      }).catch((error) => {
        this.showAlert({message: `${error.response.data.message}`});
      })
    }
  }
}
</script>